import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=136556ec&scoped=true"
import script from "./CustomFileInput.vue?vue&type=script&lang=js"
export * from "./CustomFileInput.vue?vue&type=script&lang=js"
import style0 from "./CustomFileInput.vue?vue&type=style&index=0&id=136556ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136556ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsSearchIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/SearchIcon.vue').default,IconsLicenseIcon: require('/opt/atlassian/pipelines/agent/build/components/icons/LicenseIcon.vue').default})
